module.exports = __webpack_public_path__ + "static/media/close-btn.2249a8e3.svg";